import { createAsyncThunk } from "@reduxjs/toolkit";
import { client, getError } from "../../utils/axiosClient";

export const userAuthenticate = createAsyncThunk(
  "auth/login",
  async (
    {
      email,
      password,
      isMobile,
    }: {
      email: string;
      password: string;
      isMobile: boolean;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await client.post("/auth/login", {
        email,
        password,
        isMobile,
      });

      localStorage.setItem("user", JSON.stringify(response.data));
      console.log(response.data, "user obj");
      return response.data;
    } catch (error) {
      console.log(error, "error");
      return rejectWithValue(getError(error));
      //return error;
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "auth/update-profile",
  async (
    payload: {
      firstname?: string;
      lastname?: string;
      mobile?: string;
      profilePicture?: string;
      profilePictureColorCode?: string;

      company?: string;
      jobTitle?: string;
      location?: string;
      lat?: number;
      long?: number;
      showJobTitle?: boolean;
      showPhoneNumber?: boolean;
      showCompanyName?: boolean;
    },
    { rejectWithValue }
  ) => {
    try {
      console.log(payload, "hello prof req");
      const response = await client.put("/auth/update-user", payload);

      console.log(response, "hello prof res");
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      //return error;
    }
  }
);

export const userAuthenticateGoogle = createAsyncThunk(
  "auth/login-google",
  async (
    {
      email,
      accessToken,
      lastName,
      firstName,
      profilePicture,
    }: {
      email: string;
      accessToken: string;
      lastName: string;
      firstName: string;
      profilePicture: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await client.post("/auth/google-login", {
        email,
        isMobile: false,
        accessToken,
        lastName,
        firstName,
        profilePicture,
      });
      console.log(response.data);

      localStorage.setItem("user", JSON.stringify(response.data));
      console.log(response.data, "user obj");
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      //return error;
    }
  }
);

export const getCurrentWorkSpaceRole = createAsyncThunk(
  "auth/getCurrentWorkSpaceRole",
  async (_, { rejectWithValue }) => {
    try {
      const response = await client.get("/settings/get-current-workspace-role");
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      //return error;
    }
  }
);
